import React, { useEffect, useRef, useState } from "react";
import { Formik, FieldArray, Field } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategories } from "../../store/slices/categorySlice";
import LayoutPresta from "./layoutPresta";
import TextInputFormik from "../../components/inputs/TextInuputformik";
import { getMyEtablissement } from "../../store/slices/etablissementSlice";
import PrestationCard from "./prestationCard";
import { useNavigate } from "react-router-dom";
import ServicesPrestataire from "../../components/etablissement/servicesPresta";

const Services = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [initialized, setInitialized] = useState(false);
  const { selectedEtablissement } = useSelector(
    (state) => state.etablissements
  );

  useEffect(() => {
    dispatch(getMyEtablissement());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchCategories());
  }, [dispatch]);

  const validationSchema = Yup.object().shape({
    services: Yup.array()
      .of(
        Yup.object().shape({
          name: Yup.string().required("Le nom du service est requis"),
          prestations: Yup.array()
            .of(
              Yup.object().shape({
                name: Yup.string().required(
                  "Le nom de la prestation est requis"
                ),
                duree: Yup.string().required("La durée est requise"),
                description: Yup.string()
                    .max(500, "La description ne doit pas dépasser 500 caractères"),
                lieu: Yup.array()
                  .min(1, "Au moins un lieu d'intervention requis")
                  .required("Les lieux d'intervention sont requis"),
                ht: Yup.number().min(0, "Le prix doit être positif"),
                taux_tva: Yup.number()
                  .min(0, "La TVA doit être positive")
                  .max(100, "La TVA ne peut pas dépasser 100%"),
              })
            )
            .min(1, "Au moins une prestation requise"),
        })
      )
      .min(1, "Au moins un service requis"),
  });
  // console.log({ selectedEtablissement });
  let initialValues = {
    services:
      selectedEtablissement?.services?.length > 0
        ? selectedEtablissement.services.map((service) => ({
            name: service.name || "",
            serviceId: service.id || "",
            prestations: service.prestations.map((prestation) => ({
              name: prestation.name || "",
              prestationId: prestation.id || "",
              duree: prestation.duree || "",
              nbr_sceance: prestation.nbr_sceance || "",
              ht: prestation.ht || "",
              taux_tva: prestation.taux_tva || 20,
              ttc: prestation.ttc || "",
              description: prestation.description || "",
              lieu: prestation.lieu || [],
              prestation_complementaire:
                prestation.prestation_complementaire || [],
            })),
          }))
        : [
            {
              name: "",

              prestations: [
                {
                  name: "",
                  duree: "",
                  nbr_sceance: "",
                  ht: "",
                  taux_tva: 20,
                  ttc: "",
                  description: "",
                  lieu: [],
                  prestation_complementaire: [],
                },
              ],
            },
          ],
  };
  useEffect(() => {
    if (selectedEtablissement && !initialized) {
      initialValues = {
        services:
          selectedEtablissement?.services?.length > 0
            ? selectedEtablissement.services.map((service) => ({
                name: service.name || "",
                serviceId: service.id || "",
                prestations: service.prestations.map((prestation) => ({
                  name: prestation.name || "",
                  prestationId: prestation.id || "",
                  duree: prestation.duree || "",
                  nbr_sceance: prestation.nbr_sceance || "",
                  ht: prestation.ht || "",
                  taux_tva: prestation.taux_tva || 20,
                  ttc: prestation.ttc || "",
                  description: prestation.description || "",
                  lieu: prestation.lieu || [],
                  prestation_complementaire:
                    prestation.prestation_complementaire || [],
                })),
              }))
            : [
                {
                  name: "",
                  prestations: [
                    {
                      name: "",
                      duree: "",
                      nbr_sceance: "",
                      ht: "",
                      taux_tva: 20,
                      ttc: "",
                      description: "",
                      lieu: [],
                      prestation_complementaire: [],
                    },
                  ],
                },
              ],
      };

      if (formikRef.current) {
        formikRef.current.resetForm({ values: initialValues });
      }
      setInitialized(true);
    }
  }, [selectedEtablissement, initialized]);
  const handleSubmit = (values) => {
    navigate("/equipe");
  };

  const formikRef = useRef();

  return (
    <LayoutPresta
      currentStep={5}
      nextStep={"/equipe"}
      handleSubmit={handleSubmit}
      btn={false}
    >
      <div className="col-md-6 mx-auto mt-48">
        {selectedEtablissement && <ServicesPrestataire selectedEtablissement={selectedEtablissement} />}
        
      </div>

      <div className="ht-100"></div>
    </LayoutPresta>
  );
};

export default Services;
